import React, { useState, useEffect } from 'react'
import { Avatar, Button, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, Switch, TextField } from '@mui/material'
import { toast } from 'react-toastify'

import './gestionarCuenta.css'
import iconUpPhoto from '../contactos/iconUpPhoto.svg'

import { Settings } from '../../models/settings'
import { DialogPreviewImage } from '../modals/previewImage/DialogPreviewImage'
import { uploadFile } from '../../firebase/config'
import { DialogListaPermisos } from './DialogListaPermisos'

export const InformacionEmpresa = () => {

  // const { uid } = useSelector(state => state.auth)
  const [form, setForm] = useState({
    id: '',
    url_foto: '',
    nombre_comercial: '',
    razon_social: '',
    ruc: '',
    giro: '',
    email: '',
    fono: '',
    direccion: '',
    sitio_web: ''
  })

  const getInfo = async () => {
    const data = await Settings.getInfoProp()
    setForm(data)
  }

  useEffect(() => {
    getInfo()
  }, [])

  return (
    <div className='container'>
      <BusinessInfo
        form={form}
        setForm={setForm}
      />
      <UsersAdmin
        uid={null}
      />
    </div>
  )
}

const BusinessInfo = ({ form, setForm }) => {

  // const dispatch = useDispatch()
  const [openFiles, setOpenFiles] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  const handleChange = ({ target }) => {
    console.log(target.name, target.value)
    setForm({
      ...form,
      [target.name]: target.value
    })
  }

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0])
      setOpenFiles(true)
    }
  }

  const handleUpload = () => {
    document.getElementById('profile_picture').click()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log('form', form)

    if (form.nombre_comercial === '' || form.nombre_comercial === null) {
      toast.warn("Falta completar nombre comercial")
      return false
    }

    if (form.razon_social === '' || form.razon_social === null) {
      toast.warn("Falta completar razón social")
      return false
    }

    if (form.ruc === '' || form.ruc === null) {
      toast.warn("Falta completar RUC")
      return false
    }

    let dataForm = form

    if (selectedImage) {
      const fileName = `empresa-${form.id || 0}`
      const path = `logo_empesas/${fileName}`
      try {
        const urlFoto = await uploadFile(selectedImage, path)
        dataForm.url_foto = urlFoto

      } catch (error) {
        console.log(error)
        toast.error("Fallo al guardar foto. Intente nuevamente.")
      }
    }

    await Settings.update(dataForm)
    setSelectedImage(null)

    setForm({
      ...form,
      url_foto: dataForm.url_foto,
    })

  }

  return (

    <div className="p-container-info-personal">

      <div className="row p-contet-title-info-personal">
        <div className="col-12">
          <h3 className='text-start p-title-info-personal'>Ajustes de la empresa</h3>
        </div>
        <div className="col-12 p-text-info-personal">
          <h6>Algunos datos se mostraran en la impresión de presupuestos y órdenes de compra</h6>
        </div>
      </div>

      <form onSubmit={handleSubmit} className='mt-4'>

        <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
          <Grid item xs={12}>
            <div className='d-flex justify-content-center align-items-center p-container-foto mb-3'>
              {(!selectedImage & !form?.url_foto) ?
                <img
                  src={iconUpPhoto} alt="subir foto"
                  onClick={handleUpload}
                />
                :
                <Avatar
                  alt={form?.nombre}
                  src={selectedImage ? URL.createObjectURL(selectedImage) : (form?.url_foto ? form?.url_foto : iconUpPhoto)}
                  sx={{ width: 100, height: 100 }}
                  onClick={handleUpload}
                />
              }
            </div>
          </Grid>

          <input
            style={{ display: 'none' }}
            name="profile_picture"
            id="profile_picture"
            accept="image/*"
            type="file"
            onChange={imageChange}
          />

          {selectedImage && (
            <DialogPreviewImage
              open={openFiles}
              setOpen={setOpenFiles}
              setSelectedImage={setSelectedImage}
              selectedImage={selectedImage}
            />
          )}

          <Grid item xs={12} md={6}>
            <TextField
              label="Nombre comercial (*)"
              name="nombre_comercial"
              id="outlined-size-small"
              value={form?.nombre_comercial || ''}
              size="small"
              fullWidth
              placeholder='Ingrese nombre comercial'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Razon social (*)"
              name="razon_social"
              id="outlined-size-small"
              value={form?.razon_social || ''}
              size="small"
              fullWidth
              placeholder='Ingrese razón social'
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="RUC (*)"
              name="ruc"
              id="outlined-size-small"
              value={form?.ruc || ''}
              size="small"
              fullWidth
              placeholder='Ingrese nombre comercial'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Giro/Actividad"
              name="giro"
              id="outlined-size-small"
              value={form?.giro || ''}
              size="small"
              fullWidth
              placeholder='Ingrese giro/actividad'
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <div className='p-input-email'>
              <TextField
                disabled
                label="Correo electrónico"
                name="email"
                id="outlined-size-small"
                value={form?.email || ''}
                size="small"
                fullWidth
                placeholder='Ingrese nombre'
                onChange={handleChange}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Teléfono"
              name="fono"
              id="outlined-size-small"
              value={form?.fono || ''}
              size="small"
              fullWidth
              placeholder='Ingrese número teléfono '
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Dirección"
              name="direccion"
              id="outlined-size-small"
              value={form?.direccion || ''}
              size="small"
              fullWidth
              placeholder='Ingrese dirección'
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <div className='p-input-email'>
              <TextField
                label="Sitio web"
                name="sitio_web"
                id="outlined-size-small"
                value={form?.sitio_web || ''}
                size="small"
                fullWidth
                placeholder='Ingrese sitio web'
                onChange={handleChange}
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <div>
              <Button
                id="id-button-save-ppto"
                style={{ width: '170px' }}
                className='p-btn-primary'
                variant="contained"
                size='medium'
                type='submit'
              >
                Guardar cambios
              </Button>
            </div>
          </Grid>
        </Grid>
      </form>

    </div>

  )
}

const UsersAdmin = ({ uid }) => {

  // const [error, setError] = useState(null)
  const [openNewUser, setOpenNewUser] = useState(false)
  const [usersList, setUsersList] = useState([])

  const [openPermisos, setOpenPermisos] = useState(false)
  const [userSelected, setUserSelected] = useState({})

  // const [form, setForm] = useState({
  //   id: uid,
  //   password_actual: '',
  //   password_new: '',
  //   password_confirm: '',
  // })

  useEffect(() => {
    getUsersList()
  }, [])

  const getUsersList = async () => {
    setUsersList(await Settings.getUsers())
  }

  // const handleChange = ({ target }) => {
  //   console.log(target.name, target.value)
  //   setForm({
  //     ...form,
  //     [target.name]: target.value
  //   })
  // }

  // const handleSubmit = async (e) => {
  //   e.preventDefault()

  //   setError(null)

  //   if (form.password_actual !== '' && form.password_new !== '' && form.password_confirm !== '') {

  //     if (form.password_new.length < 8) {
  //       setError(3)
  //       return false
  //     }

  //     if (form.password_new !== form.password_confirm) {
  //       setError(4)
  //       return false
  //     }

  //     const resultUpdate = await Settings.updatePassword(form)

  //     if (resultUpdate.error === 1) {
  //       setError(1)
  //       return false
  //     }

  //     if (resultUpdate.error === 2) {
  //       setError(2)
  //       return false
  //     }

  //     setForm({
  //       ...form,
  //       password_actual: '',
  //       password_new: '',
  //       password_confirm: '',
  //     })

  //   }

  // }

  const handleChangeEstado = async ({ target }, id) => {
    const estado = target.checked

    const newList = usersList.map(it => {
      if (parseInt(it.id) === parseInt(id)) {
        return {
          ...it,
          [target.name]: target.checked
        }
      } else {
        return it
      }

    })

    setUsersList(newList)

    await Settings.updateEstadoUser(
      {
        id,
        estado,
        nombre: target.name
      }
    )

  }

  const handleOpenPermisos = (user) => {
    setUserSelected(user)
    setOpenPermisos(true)
  }

  return (

    <>

      {openPermisos &&
        <DialogListaPermisos
          open={openPermisos}
          setOpen={setOpenPermisos}
          user={userSelected}
        />
      }

      <div className="p-container-info-personal mt-4">

        <div className="row p-contet-title-info-personal">
          <div className="col ">
            <h3 className='text-start p-title-info-personal'>Administrar usuarios</h3>
          </div>
          <div className="col-12 p-text-info-personal">
            <h6>Protege tus datos creando una contraseña que sea compleja y tenga la longitud suficiente. Debe resultarte fácil de recordar pero difícil de adivinar para los demás.</h6>
          </div>
        </div>

        <div className='p-container-users'>
          <div>
            <Button
              id="id-button-save-ppto"
              style={{ width: '120px' }}
              className='p-btn-primary'
              variant="contained"
              size='medium'
              type='button'
              onClick={() => setOpenNewUser(!openNewUser)}
            >
              {openNewUser ? ' - Usuarios' : ' + Usuarios'}
            </Button>
          </div>

          {openNewUser &&
            <NewUser />
          }

          <div className="table-responsive mt-4">
            <table className="table p-table-global text-center">
              <thead className='p-thead-global'>
                <tr className="text-center p-tr-titles-global">
                  <th className='text-start'>Usuario/login</th>
                  <th className='text-start'>Nombre</th>
                  <th className='text-start'>Email</th>
                  <th className='text-start'>Perfil</th>
                  <th>Usuario tarea</th>
                  <th>Cambiar estado</th>
                  <th>Permisos</th>
                </tr>
              </thead>
              <tbody>
                {usersList.length > 0 && usersList?.map(user => (
                  <tr key={user.id}>
                    <td className='text-start'>{user.login}</td>
                    <td className='text-start' style={{ textTransform: 'capitalize' }}>{user.nombre}{' '}{user.apellidos}</td>
                    <td className='text-start'>{user.email}</td>
                    <td className='text-start' style={{ textTransform: 'capitalize' }}>{user.perfil}</td>
                    {/* <td>
                    <i className="bi bi-pencil" style={{ cursor: 'pointer' }}></i>
                  </td> */}
                    <td className='text-center'>
                      <FormControlLabel
                        value="start"
                        name="usuario_tarea"
                        className='afecto-label'
                        checked={user.usuario_tarea}
                        control={<Switch color="primary" />}
                        label={user.usuario_tarea ? "Activo" : 'Desactivado'}
                        labelPlacement="start"
                        onChange={(e, id) => handleChangeEstado(e, user.id)}
                      />
                    </td>
                    <td className='text-center'>
                      <FormControlLabel
                        value="start"
                        name="estado"
                        className='afecto-label'
                        checked={user.estado}
                        control={<Switch color="primary" />}
                        label={user.estado ? "Activo" : 'Desactivado'}
                        labelPlacement="start"
                        onChange={(e, id) => handleChangeEstado(e, user.id)}
                      />
                    </td>
                    <td>
                      <i
                        className="bi bi-key"
                        style={{ fontSize: '20px', cursor: 'pointer' }}
                        onClick={() => handleOpenPermisos(user)}
                      ></i>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

      </div>

    </>

  )
}

const NewUser = () => {

  const [perfiles, setPerfiles] = useState([])

  useEffect(() => {
    getPerfiles()
  }, [])

  const getPerfiles = async () => {
    setPerfiles(await Settings.getPerfiles())
  }

  const [form, setForm] = useState({
    id: 0,
    login: '',
    email: '',
    nombre: '',
    apellidos: '',
    id_perfil: '',
    estado: true
  })

  const handleChange = ({ target }) => {
    console.log(target.name, target.value)
    setForm({
      ...form,
      [target.name]: target.value
    })
  }

  const handleSubmitNewUser = async (e) => {
    e.preventDefault()
    console.log(form)

    if (form.email === '' || form.email === null) {
      toast.warn("Falta completar email")
      return false
    }

    if (form.nombre === '' || form.nombre === null) {
      toast.warn("Falta completar nombre")
      return false
    }

    if (form.apellidos === '' || form.apellidos === null) {
      toast.warn("Falta completar apellidos")
      return false
    }

    if (form.nombre === '' || form.nombre === null) {
      toast.warn("Falta seleccionar un perfil")
      return false
    }

    const resultSave = await Settings.saveNewUser(form)

    setForm({
      ...form,
      id: resultSave.id,
      login: resultSave.login
    })

  }

  return (
    <form onSubmit={handleSubmitNewUser} className='mt-3'>
      <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>

        <Grid item>
          <div className='p-input-email'>
            <TextField
              className='p-'
              label="Email (*)"
              name="email"
              id="outlined-size-small"
              value={form.email || ''}
              size="small"
              fullWidth
              placeholder='Ingrese email'
              onChange={handleChange}
            />
          </div>
        </Grid>

        <Grid item>
          <TextField
            label="Nombre (*)"
            name="nombre"
            id="outlined-size-small"
            value={form.nombre || ''}
            size="small"
            fullWidth
            placeholder='Ingrese nombre'
            onChange={handleChange}
          />
        </Grid>

        <Grid item>
          <TextField
            label="Apellidos (*)"
            name="apellidos"
            id="outlined-size-small"
            value={form.apellidos || ''}
            size="small"
            fullWidth
            placeholder='Ingrese nombre'
            onChange={handleChange}
          />
        </Grid>

        <Grid item>
          <FormControl fullWidth size="small">
            <InputLabel id="demo-simple-select-label">Perfil (*)</InputLabel>
            <Select
              label="Perfil (*)"
              id="id_perfil"
              name="id_perfil"
              value={form.id_perfil || ''}
              onChange={handleChange}
              style={{ width: '200px' }}
              className='p-list-capitalize'
            >
              <MenuItem value='' key=''>Ninguno</MenuItem>
              {perfiles.length > 0 && perfiles?.map(item => (
                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <div>
            <Button
              id="id-button-save-ppto"
              style={{ width: '100px' }}
              className='p-btn-primary'
              variant="contained"
              size='medium'
              type='submit'
            >
              Agregar
            </Button>
          </div>
        </Grid>

      </Grid>
    </form>
  )
}